(function () {
  'use strict';

  var SELECTOR = '.oddit-announcement-bar';
  var DEFAULT_INTERVAL = 5000;

  function initBar(bar) {
    if (!bar || bar.dataset.announcementInitialized === 'true') return;
    if (!bar.hasAttribute('data-announcement-rotate')) return;

    var slides = bar.querySelectorAll('[data-announcement-slide]');
    if (slides.length < 2) return; // nothing to rotate

    bar.dataset.announcementInitialized = 'true';

    var motionQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    var interval = parseInt(bar.getAttribute('data-announcement-interval'), 10) || DEFAULT_INTERVAL;
    var index = 0;
    var timer = null;

    function show(next) {
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      slides[index].setAttribute('aria-hidden', 'false');
    }

    function advance() {
      show(index + 1);
    }

    function start() {
      stop();
      if (motionQuery && motionQuery.matches) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Pause on hover/focus so a reader isn't interrupted, and when the tab is
    // hidden so we don't rotate off-screen.
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if (motionQuery) {
      var onMotionChange = function () {
        if (motionQuery.matches) {
          stop();
          show(0);
        } else {
          start();
        }
      };
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
      else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
    }

    start();
  }

  function init() {
    var bars = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < bars.length; i++) {
      initBar(bars[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
    if (bar) initBar(bar);
  });
})();
